import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';


const ManageColumn = ({ columns, visibleColumns, onColumnToggle }: any) => {
    const [checkedItems, setCheckedItems] = useState(visibleColumns);

    // Synchronize checkedItems with visibleColumns when it changes
    useEffect(() => {
        setCheckedItems(visibleColumns);
    }, [visibleColumns]);

    const handleCheckboxChange = (id: any) => {
        const updatedCheckedItems = {
            ...checkedItems,
            [id]: !checkedItems[id], // Toggle the checkbox for the column
        };
        setCheckedItems(updatedCheckedItems); // Update local state
        onColumnToggle(updatedCheckedItems); // Notify parent component of the change
    };

    return (
        <div className="manage-dropdown ">
            <Link
                to="#"
                className="btn btn-purple-light d-flex gap-1 justify-content-center px-4"
                data-bs-toggle="dropdown"
                data-bs-auto-close="false"
            >
                <i className="ti ti-columns-3" />
                Manage Columns
            </Link>
            <div className="dropdown-menu dropdown-manageColums dropdown-menu-md-end manageColumn-width">
                <ul>
                    {columns?.map((column: any) => (
                        <li key={column.id}>
                            <p>
                                <i className="ti ti-grip-vertical" />
                                {column.name}
                            </p>
                            <div className="status-toggle">
                                <input
                                    type="checkbox"
                                    id={`col-name-${column.id}`}
                                    className="check"
                                    checked={checkedItems[column.id] || false}
                                    onChange={() => handleCheckboxChange(column.id)}
                                />
                                <label htmlFor={`col-name-${column.id}`} className="checktoggle" />
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default ManageColumn;
